export default __webpack_public_path__ + "static/media/List.bd4d75a0.svg";